import React from "react";
import "./ProcessingIndicator.css";

/**
 * Processing indicator shown on tiles while API calls are pending
 * Similar visual style to PlannedActionIcon but with spinning animation
 */
export default function ProcessingIndicator({ type = 'action' }) {
  return (
    <div className={`processing-indicator processing-${type}`}>
      <div className="processing-spinner" />
    </div>
  );
}
